export default __webpack_public_path__ + "static/partner2-d1a6a544ae11f6379a6f1ce06956aba2.png";